import $ from 'jquery'

export default function (
  $scrollToThis: JQuery,
  $revealThis: JQuery,
  $hideThis: JQuery | null,
  scrollPadding: number
): void {
  if ($scrollToThis.length && $revealThis.length) {
    $(window).on('scroll', function () {
      if (
        $(window).scrollTop()! >
        $scrollToThis.offset()!.top - scrollPadding
      ) {
        $revealThis.toggle(true)
        if ($hideThis) {
          // Hide something that might show through the sticky nav so that it doesn't show through.
          // Use visibility vs display so that the layout doesn't change.
          $hideThis.toggleClass('invisible-except-xs', true)
        }
      } else {
        $revealThis.toggle(false)
        if ($hideThis) {
          $hideThis.toggleClass('invisible-except-xs', false)
        }
      }
    })
  }
}
